import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[extlinks]'
})
export class ExtLinksDirective {
	@Input('extlinks') links: string[] = [];
	
	constructor(private el: ElementRef) {}
	
	setLinks() {
		let el = this.el.nativeElement;
		let container = el.querySelector('ul');
		
		let buttons = container.querySelectorAll('li');
		
		for(let button of buttons) {
			let a = button.querySelector('a');
			let pageNumber = parseInt(a.textContent);
			if ( ! isNaN(pageNumber)) {
				a.setAttribute('href', this.links[pageNumber - 1]);
			}
		}
	}
	
	ngOnChanges() {
		this.setLinks();
	}
	
	ngAfterViewInit() {
		this.setLinks();
	}
}
